<template>
  <li class="LmDetailComment" :class="{'is-highlight': showHighlight}">
    <header class="Header">
      <user-info :user="user" compacted>
        <span :title="content.createdAt | formattedDate">
          {{ content.createdAt | dateFromNow('Now') }}
        </span>
      </user-info>
      <lm-dropdown
        v-if="adminRights"
        class="Options"
        :items="options"
        auto-close
        @select="onSelect"
      />
    </header>
    <div class="Body" :class="{'is-new': newComment}">
      <div
        v-img-clickable
        v-iframe-container
        v-a-blank-target
        class="CommentContent"
        v-html="linkifiedText"
      />
      <span
        v-if="content.editedBy"
        class="block mt-2 mb-5 italic text-gray-500 text-xxs"
      >
        Edited by {{ getUserByID(content.editedBy.user).username }}
        {{ content.editedBy.date | dateFromNow }} ago
      </span>
    </div>
    <footer class="Footer">
      <lm-vote-button
        :votes="content.positiveVotes"
        :state="votedPositive"
        @click="voteComment('positiveVote')"
      />
      <lm-reply-button :author-id="content.author" />
    </footer>
  </li>
</template>

<script>
import UserInfo from '@/components/landscape/topics/UserInfo'
import {mapGetters} from 'vuex'
import linkifyHtml from 'linkifyjs/html'
import LmDropdown from '@/components/ui/LmDropdown'
import LmVoteButton from '@/components/ui/LmVoteButton'
import LmReplyButton from '@/components/ui/LmReplyButton'

export default {
  name: 'LmDetailComment',
  components: {UserInfo, LmVoteButton, LmReplyButton, LmDropdown},
  props: {
    adminRights: {
      type: Boolean,
      default: true
    },
    content: {
      type: Object,
      required: true
    },
    newComment: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return [
          {action: 'edit', label: 'Edit comment'},
          {action: 'delete', label: 'Delete comment'}
        ]
      }
    }
  },
  data() {
    return {
      showHighlight: false
    }
  },
  computed: {
    ...mapGetters(['getUserByID']),
    user() {
      return this.getUserByID(this.content.author)
    },
    linkifiedText() {
      return this.content && this.content.text
        ? linkifyHtml(this.content.text)
        : ''
    },
    votedPositive() {
      return this.content.currentUser.positiveVote
    },
    votedNegative() {
      return this.content.currentUser.negativeVote
    }
  },
  methods: {
    onSelect(item) {
      this.$emit('optionSelected', item, this.content._id)
    },
    voteComment(type) {
      let v
      if (type === 'positiveVote') {
        v = !this.votedPositive
      } else if (type === 'negativeVote') v = !this.votedNegative
      this.$emit('vote', {[type]: v}, this.content._id)
    },
    // PUBLIC
    highlight() {
      this.showHighlight = true
      const cssAnimationDuration = 3000
      setTimeout(() => {
        this.showHighlight = false
      }, cssAnimationDuration)
    }
  }
}
</script>

<style scoped>
@keyframes highlight {
  0% {
    background: aliceblue;
  }
  100% {
    background: none;
  }
}

.LmDetailComment {
  margin: 32px 0;
  &.is-highlight {
    animation: highlight 3s;
    margin: -16px -20px 16px;
    padding: 0.1px 20px;
  }
}
.Header,
.Body,
.Footer {
  margin: 16px 0;
}
.Header,
.Footer {
  display: flex;
  align-items: center;
}
.Body,
.Footer {
  margin-left: 32px;
}
.Header {
  margin-bottom: 12px;
}
.Body {
  margin-top: 12px;
  position: relative;
  &.is-new:before {
    content: '';
    position: absolute;
    top: 6px;
    left: -23px;
    width: 7px;
    height: 7px;
    background-color: theme('colors.highlight');
    border-radius: 100%;
  }
}
.CommentContent {
  color: theme('colors.gray.700');
  margin-right: 24px;
}
.Options {
  margin-left: auto;
}
.Footer button {
  margin-right: 8px;
}
</style>
<style>
.LmDetailComment .CommentContent p:last-child {
  margin-bottom: 0;
}
</style>
